<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{ 'Transferir para Igreja' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>
  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div>
      <ion-card-content>
        <ion-item class="switcher-item" lines="none">
          <ion-input
            labelPlacement="stacked"
            type="decimal"
            placeholder="{{'Digite o Valor' | translate}}"
            formControlName="valor"
            (ionInput)="formatValor($event)"
          >
            <div slot="label">
              {{'Valor' | translate}}
              <ion-text color="danger">*</ion-text>
            </div></ion-input
          >
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.valor">
            <div
              class="error-message"
              *ngIf="validations_form.get('valor')?.hasError(validation.type) && (validations_form.get('valor')?.dirty || validations_form.get('valor')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ng-container>
          <prover-datepicker
            [labelName]="'Data do Lançamento'"
            [id]="'data'"
            formControlName="data"
            [required]="true"
          ></prover-datepicker>

          <div class="validation-errors ion-margin-start">
            <ng-container *ngFor="let validation of validation_messages.data">
              <div
                class="error-message"
                *ngIf="validations_form.get('data')?.hasError(validation.type) && (validations_form.get('data')?.dirty || validations_form.get('data')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div *ngIf="!vincularPessoa" class="down">
          <ion-button
            class="btn-success"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid || isSubmitting"
          >
            {{'Salvar' | translate}}
          </ion-button>
        </div>
      </ion-card-content>
    </div>
  </form>
</ion-content>
